// extracted by mini-css-extract-plugin
module.exports = {"book":"Book_book__1K3aX","rating":"Book_rating__291Mr"};